import { createFileRoute, notFound } from "@tanstack/react-router";

import { partCategoriesQueries } from "@/api/resources/partCategories/queries";
import { partManufacturersQueries } from "@/api/resources/partManufacturers/queries";
import { partModelsQueries } from "@/api/resources/partModels/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { CustomInventoryPartsPage } from "@/components/CustomInventory/CustomInventoryPartsPage";
import { DEFAULT_DATATABLE_OPTIONS } from "@/configs/datatable";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";
import { defaultSortByNameAsc } from "@/utils/pagination";

import type { BreadcrumbsContext } from "@/providers/routerConfig";
import type { QueryFilter } from "@/utils/filter";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/custom-inventory/parts/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.custom-inventory-parts"),
        icon: <Icon.PARTS />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    await context.queryClient.ensureQueryData(
      partCategoriesQueries.listPaginated({
        dataTableOptions: {
          ...DEFAULT_DATATABLE_OPTIONS,
          ...defaultSortByNameAsc,
        },
        customFilters: [["workspace_id", "eq", currentWorkspace.id] as QueryFilter],
      }),
    );
    await context.queryClient.ensureQueryData(
      partManufacturersQueries.listPaginated({
        dataTableOptions: {
          ...DEFAULT_DATATABLE_OPTIONS,
          ...defaultSortByNameAsc,
        },
        customFilters: [["workspace_id", "eq", currentWorkspace.id] as QueryFilter],
      }),
    );
    await context.queryClient.ensureQueryData(
      partModelsQueries.listPaginated({
        dataTableOptions: {
          ...DEFAULT_DATATABLE_OPTIONS,
          ...defaultSortByNameAsc,
        },
        customFilters: [["workspace_id", "eq", currentWorkspace.id] as QueryFilter],
      }),
    );
  },
  component: CustomInventoryPartsPage,
});
